module.exports = __webpack_public_path__ + "media/images/game_icon/vi/VG1003-ce403eb7f1f53fb1f7e70b19c77bd159.png";